import { useDispatch } from "react-redux";

// Actions
import {
  searchGamesChange,
  setCategory,
  setProviderFilter,
} from "redux/game/slice";

// Components
import CategoryMobile from "components/organisms/CategoryMobile";
import SkeletonCarouselCategories from "components/molecules/SkeletonCarouselCategories";

// Constants
import { CATEGORIES_ENUMS } from "constants/navigation/categories";

// Hooks
import { useGTM } from "hooks/useGTM";
import { useLoaderStore } from "stores/loader";

// Selectors
import { useCatalogsStore } from "stores/catalogs";

const CategoryMobileContainer = () => {
  const dispatch = useDispatch();
  const GTM = useGTM();
  const isLocalizationLoaded = useCatalogsStore(
    (state) => state.isLocalizationLoaded,
  );
  const { overlayLoading } = useLoaderStore();

  if (overlayLoading) {
    return <SkeletonCarouselCategories />;
  }

  const handleCategorySelect = (category: CATEGORIES_ENUMS) => {
    dispatch(setProviderFilter(null));
    dispatch(setCategory(category));
    GTM.clickCategoryChoise(category);
    dispatch(searchGamesChange(""));
  };

  return (
    <CategoryMobile
      isLocalizationLoaded={isLocalizationLoaded}
      onSelect={handleCategorySelect}
    />
  );
};

export default CategoryMobileContainer;
